import styled from "styled-components";
import theme from "../../themes/simple-theme";

export interface IProps {
  gray?: boolean;
  noPadding?: boolean;
  noBackground?: boolean;
  fullScreen?: boolean;
  fullWidth?: boolean;
  center?: boolean;
}

const Content = styled.main`
  margin-top: 5rem;
  background: ${theme.color.white};
  ${({ gray }: IProps) =>
    gray ? `background-color: ${theme.color.white};` : ``};
  ${({ noPadding = false }: IProps) => (noPadding ? `padding: 0;` : ``)};
  ${({ center }: IProps) => (center ? `text-align: center;` : ``)};
  ${({ noBackground = false }: IProps) =>
    noBackground ? `background: transparent;` : ``};
  ${({ fullScreen }: IProps) => (fullScreen ? `height: 100vh;` : ``)};

  ${({ fullWidth }: IProps) => (fullWidth ? `width: 100%;` : ``)};
`;

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/index.tsx